import { gql } from "@apollo/client";

export const TRACK = gql`
  fragment Track on Track {
    id
    code
    shortName
    name
    featured
    hasAboveTheLinePromo(product: $product, brand: $brand)
    numberOfRaces
    isGreyhound
    isFinished
    isFavorite @include(if: $isLogged)
    favorite @include(if: $isLogged) {
      id
    }
    isPromoTagShown
  }

  query getTracksAZ(
    $wagerProfile: String
    $sortByName: TrackListSort
    $trackFilters: TrackListFilter
    $product: String
    $brand: String
    $isLogged: Boolean!
  ) {
    tracks: tracks(
      profile: $wagerProfile
      sort: $sortByName
      filter: $trackFilters
    ) {
      ...Track
    }
  }
`;

export default TRACK;
